<div *ngIf="!loadDeliveryDate">
  <div
    *ngIf="schedule > 0"
    class="status"
    [ngClass]="{'mt-web': !isFordPass}">

    <h1 class="status__title
    ">{{"service-status" | translate}}</h1>
    <div class="status__card">
      <div class="status__card__container">
        <div>
          <p id="status-card-title" class="status__card__container__title">
            Status - {{ "dashboard.vehicle-delivery" | translate }}</p>
          <div>
            <span id="status-card-without-hour" class="status__card__container__date-hour"
              *ngIf="!scheduleStatusModel.deliveryScheduleDate || !scheduleStatusModel.deliveryScheduleHour">
              {{ "to-confirm" | translate | uppercase }}
            </span>
            <p id="status-card-with-hour" class="status__card__container__date-hour"
              *ngIf="scheduleStatusModel.deliveryScheduleDate && scheduleStatusModel.deliveryScheduleHour">
              <b>{{ scheduleStatusModel.deliveryScheduleDate | date: 'dd/MM/yyyy' }} - {{ scheduleStatusModel.deliveryScheduleHour | hour }}</b>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="status-list">

      <div class="status-list__tracker">
        <fds-resize-vertical-tracker label="1/3" [firstItem]="true" [completed]="deliveryTracker.completed"
          [inProgress]="deliveryTracker.inProgress"
          [disabled]="(!deliveryTracker.completed && !deliveryTracker.inProgress)"></fds-resize-vertical-tracker>
        <fds-resize-vertical-tracker label="2/3" [completed]="completedChecklist_1"
          [inProgress]="(InProgressChecklist_1 || deliveryTracker.completed)"
          [disabled]="(!completedChecklist_1 && !InProgressChecklist_1)"></fds-resize-vertical-tracker>
        <fds-resize-vertical-tracker label="3/3"
          [inProgress]="InProgressChecklist_1"
          [disabled]="(!basicTestsTracker.completed && !cleaningTracker.completed)"></fds-resize-vertical-tracker>
      </div>

      <div class="status-list__info">

        <div class="status-list__info__delivery">
          <p class="status-list__info__delivery__title" *ngIf="checkInHour === 9999">
            {{ "date-hour" | translate }}
          </p>
          <p id="status-list-with-hour"  class="status-list__info__delivery__title" *ngIf="checkInHour !== 9999">
            {{ scheduleDate | date: 'dd/MM/yyyy' }} - {{ scheduleStatusModel.checkInHour | hour }}
          </p>
          <p *ngIf="deliveryTracker.completed"
          class="status-list__info__delivery__subtitle">{{ "delivered-vehicle" | translate }}</p>
          <p *ngIf="!deliveryTracker.completed"
          class="status-list__info__delivery__subtitle">{{ "waiting-vehicle-to-delivery" | translate }}</p>
          <div class="status-list__info__delivery__attendant-container">
          <p class="status-list__info__delivery__attendant">{{ "responsible-attendant" | translate }}</p>
          <p><b>{{ advisorName | decreaseName }}</b></p>
          </div>
        </div>

        <div class="status-list__info__in-progress">
          <p class="status-list__info__in-progress__title">
            {{ 'status.in-progress' | translate }}
          </p>
          <p *ngIf="!quotationRevision.quotation">{{ "realized-services" | translate }}</p>
          <div class="status-list__info__in-progress__attendant-container">
            <p class="status-list__info__in-progress__attendant">{{ "responsible-attendant" | translate }}</p>
          <p class="status-list__info__in-progress__attendant-name">{{ advisorName | decreaseName }}</p>
          </div>


          <!-- <div class="fds-button-box" (click)="handleDialog()">
            <button class="fds-button">
              {{ "vehicle-breakdowns" | translate }}
              <img
                class="fds-button-icon"
                src="../../../../../assets/img/Icon_Arrow.svg"
                alt="go to schedule page">
              </button>
          </div> -->

          <!-- <div
            style="margin-top: -5px;"
            class="fds-button-box checklist-button"
            (click)="openChecklistSummary()">
            <button class="fds-button" type="button">
              {{ "status.checklist-summary.btn.checklist-summary" | translate }}
              <img
                class="fds-button-icon"
                src="../../../../../assets/img/Icon_Arrow.svg"
                alt="go to schedule page">
            </button>
          </div> -->


         <div id="modal">
           <app-dialog [modalCenter]="true" [opened]="dialogChange" (openedChange)="handleDialog()"
             class="status-list__info__in-progress__dialog-details">

             <h2 class="status-list__info__in-progress__dialog-details__title">{{ "service-detail" | translate }}</h2>
             <div class="status-list__info__in-progress__dialog-details__date-hour">
               <p class="status-list__info__in-progress__dialog-details__date-hour__title"><b>{{ "date-hour" | translate
                   }}</b></p>
               <p>{{ quotationRevision.quotationRevisionDate | dateHour }}</p>
             </div>

             <div class="status-list__info__in-progress__dialog-details__description">
               <p class="status-list__info__in-progress__dialog-details__description__title"><b>{{ "description" | translate
                   }}</b></p>
               <lib-table
                 class="service-container__overview__table"
                 [elements]="quotationDescriptionElements"
                 [alternativeRows]="true"
                 [noBorders]="true"></lib-table>
             </div>

             <div class="status-list__info__in-progress__dialog-details__close">
               <lib-button type="primary" [rightIcon]="true" (clickButton)="handleDialog()">Ok</lib-button>
             </div>

           </app-dialog>
         </div>

        </div>

        <div class="status-list__info__checkout">
          <p class="status-list__info__checkout__title">
            {{ "dashboard.vehicle-delivery" | translate }}
          </p>
          <p class="status-list__info__checkout__subtitle">
            {{ 'status.to-confirm' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="loadDeliveryDate" class="loading">
  <circular-indicator style="align-self: center;" [percentage]="0" [size]="100">
  </circular-indicator>
</div>
